import { render, staticRenderFns } from "./CommInput.vue?vue&type=template&id=20bfac18&lang=pug&"
import script from "./CommInput.vue?vue&type=script&lang=js&"
export * from "./CommInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports